//物流菜单
import wuliukehuguanli from "@/components/wuliu/wuliukehuguanli";
import baojiamuban from "@/components/wuliu/kehu/baojiamuban";
import baojiamubanPerson from "@/components/wuliu/kehu/baojiamubanPerson";
import yewubaojia from "@/components/wuliu/kehu/yewubaojia";
import kehubaojia from "@/components/wuliu/kehu/kehubaojia";
import wuliugongyingshangguanli from "@/components/wuliu/wuliugongyingshangguanli";
import yunshushijian from "@/components/wuliu/yunshushijian";
import yunshurenwu from "@/components/wuliu/yunshurenwu";
import caiwufenxi from "@/components/wuliu/caiwu/caiwufenxi";
import shouzhijilu from "@/components/wuliu/caiwu/shouzhijilu";
import taizhangguanli from "@/components/wuliu/caiwu/taizhangguanli";

import dingdanxinxi from "@/components/wuliu/dingdan/dingdanxinxi";
import dingdanmuban from "@/components/wuliu/dingdan/dingdanmuban";
import dingdanhecha from "@/components/wuliu/dingdan/dingdanhecha";
import danhaopeizhi from "@/components/wuliu/dingdan/danhaopeizhi";

import daifenpaidingdan from "@/components/wuliu/xiaoshou/daifenpai";
import baifangjilu from "@/components/wuliu/xiaoshou/baifangjilu";
import xiaoshoudingdan from "@/components/wuliu/xiaoshou/xiaoshoudingdan";
import mubanguanli from "@/components/wuliu/xiaoshou/mubanguanli";
import caiwumubanguanli from "@/components/wuliu/caiwu/mubanguanli";

import anpaicheliang from "@/components/wuliu/fahuo/anpaicheliang";
import diaoduwancheng from "@/components/wuliu/fahuo/diaoduwancheng";
import guanwuchuli from "@/components/wuliu/fahuo/guanwuchuli";
import fendanpeizai from "@/components/wuliu/fahuo/fendanpeizai";
import huowupeisong from "@/components/wuliu/fahuo/huowupeisong";
import jichuxinxi from "@/components/wuliu/fahuo/jichuxinxi";
import kehutuihuo from "@/components/wuliu/fahuo/kehutuihuo";
import shangmentihuo from "@/components/wuliu/fahuo/shangmentihuo";
import xitongkaidan from "@/components/wuliu/fahuo/xtkd.vue";
import yunshushijian1 from "@/components/wuliu/fahuo/yunshushijian";

import sijigongzi from "@/components/wuliu/caiwu/sijigongzi";
import yingshouzhangkuan from "@/components/wuliu/caiwu/yingshouzhangkuan";
import yingfuzhangkuan from "@/components/wuliu/caiwu/yingfuzhangkuan";
import caiwushenhe from "@/components/wuliu/caiwu/caiwushenhe";
import kaipiaoguanli from "@/components/wuliu/caiwu/kaipiaoguanli";
import huilvgonggong from "@/components/wuliu/caiwu/huilvgonggong";
import huilvsiyou from "@/components/wuliu/caiwu/huilvsiyou";
import sjccjl from "@/components/wuliu/fahuo/sijichuchejilu";
import exportTemplet from "@/components/wuliu/kehu/daochumuban";
import diaodukanban from "@/components/wuliu/diaodukanban/";
import paibanbiao from "@/components/wuliu/fahuo/paibanbiao";

import fukuanshenqing from "@/components/wuliu/caiwufeiyong/fukuanshenqing";
import baoxiaoshenqing from "@/components/wuliu/caiwufeiyong/baoxiaoshenqing";
import daibanshenpi from "@/components/wuliu/caiwufeiyong/daibanshenpi"; //enentWait
import yibanchaxun from "@/components/wuliu/caiwufeiyong/yibanchaxun"; //eventAllList
import liuchengpeizhi from "@/components/wuliu/caiwufeiyong/liuchengpeizhi";

import zhengchelirun from "@/components/wuliu//report/zhengchelirun";
import sijilirun from "@/components/wuliu/report/sijilirun";
import danpiaolirun from "@/components/wuliu/report/danpiaolirun";
import sijibaoxiao from "@/components/wuliu/report/sijibaoxiao";
import sijichanzhi from "@/components/wuliu/report/sijichanzhi";
import kehufahuo from "@/components/wuliu/report/kehufahuo";
import kehuqiankuan from "@/components/wuliu//report/kehuqiankuan";
import yewuxiaoshou from "@/components/wuliu/report/yewuxiaoshou";
import diaodutongji from "@/components/wuliu/report/diaodutongji";

import area from "@/components/wuliu/fahuo/area";
import profitAnalyse from "@/components/wuliu/caiwu/maolifenxi";

var data = [
  {
    path: "/wlkehuguanli",
    component: wuliukehuguanli
  },
  {
    path: "/wlgongyingshangguanli",
    component: wuliugongyingshangguanli
  },
  {
    path: "/wlkehuguanli",
    component: wuliukehuguanli
  },
  {
    path: "/wlgongyingshangguanli",
    component: wuliugongyingshangguanli
  },
  {
    path: "/priceTemplet",
    component: baojiamuban
  },
  {
    path: "/baojiamubanPerson",
    component: baojiamubanPerson
  },
  {
    path: "/yewubaojia",
    component: yewubaojia
  },
  {
    path: "/kehubaojia",
    component: kehubaojia
  },
  {
    path: "/caiwushenhe",
    component: caiwushenhe
  },
  {
    path: "/kaipiaoguanli",
    component: kaipiaoguanli
  },
  {
    path: "/commonRate",
    component: huilvgonggong
  },
  {
    path: "/customerRate",
    component: huilvsiyou
  },
  {
    path: "/yingshouzhangkuan",
    component: yingshouzhangkuan
  },
  {
    path: "/yingfuzhangkuan",
    component: yingfuzhangkuan
  },
  {
    path: "/tallyBook",
    component: shouzhijilu
  },
  {
    path: "/tallyAccount",
    component: taizhangguanli
  },
  {
    path: "/xitongkaidan",
    component: xitongkaidan
  },
  {
    path: "/yunshushijian1",
    component: yunshushijian1
  },
  {
    path: "/driverSalary",
    component: sijigongzi
  },
  {
    path: "/yunshurenwu",
    component: yunshurenwu
  },
  {
    path: "/baifangjilu",
    component: baifangjilu
  },
  {
    path: "/xiaoshoudingdan",
    component: xiaoshoudingdan
  },
  {
    path: "/mubanguanli",
    component: mubanguanli
  },
  {
    path: "/fmsExportTmpl",
    component: caiwumubanguanli
  },
  {
    path: "/guanwuchuli",
    component: guanwuchuli
  },
  {
    path: "/fendanpeizai",
    component: fendanpeizai
  },
  {
    path: "/huowupeisong",
    component: huowupeisong
  },
  {
    path: "/duwc",
    component: diaoduwancheng
  },
  {
    path: "/jichuxinxi",
    component: jichuxinxi
  },
  {
    path: "/kehutuihuo",
    component: kehutuihuo
  },
  {
    path: "/caiwufenxi",
    component: caiwufenxi
  },
  {
    path: "/shangmentihuo",
    component: shangmentihuo
  },
  {
    path: "/dingdanxinxi",
    component: dingdanxinxi
  },
  {
    path: "/danhaopeizhi",
    component: danhaopeizhi
  },
  {
    path: "/dingdanmuban",
    component: dingdanmuban
  },
  {
    path: "/dingdanhecha",
    component: dingdanhecha
  },
  {
    path: "/daifenpaidingdan",
    component: daifenpaidingdan
  },
  {
    path: "/yunshushijian",
    component: yunshushijian
  },
  {
    path: "/anpaicheliang",
    component: anpaicheliang
  },
  {
    path: "/wlkehuguanli",
    component: wuliukehuguanli
  },
  {
    path: "/wlgongyingshangguanli",
    component: wuliugongyingshangguanli
  },
  {
    path: "/zclrbb",
    component: zhengchelirun
  },
  {
    path: "/sjlrbb",
    component: sijilirun
  },
  {
    path: "/dplrbb",
    component: danpiaolirun
  },
  {
    path: "/sjbxbb",
    component: sijibaoxiao
  },
  {
    path: "/sjczbb",
    component: sijichanzhi
  },
  {
    path: "/khfhbb",
    component: kehufahuo
  },
  {
    path: "/khqkbb",
    component: kehuqiankuan
  },
  {
    path: "/ywxsbb",
    component: yewuxiaoshou
  },
  {
    path: "/ddtjbb",
    component: diaodutongji
  },
  {
    path: "/fkApply",
    component: fukuanshenqing
  },
  {
    path: "/bxApply",
    component: baoxiaoshenqing
  },
  {
    path: "/costFlowPending",
    component: daibanshenpi
  },
  {
    path: "/costFlowHistory",
    component: yibanchaxun
  },
  {
    path: "/flowConfig",
    component: liuchengpeizhi
  },
  {
    path: "/sjccjl",
    component: sjccjl
  },
  {
    path: "/exportTemplet",
    component: exportTemplet
  },
  {
    path: "/diaodukanban",
    component: diaodukanban
  },
  {
    path: "/paibanbiao",
    component: paibanbiao
    //http://localhost:2331/#/paibanbiao?now=4
  },
  {
    path: "/area",
    component: area
  },
  {
    path: "/profitAnalyse",
    component: profitAnalyse
  },
  {
    path: "/czyddtjbb",
    component: () => import("@/components/wuliu/fenxi/caoZuoYuan.vue")
  },
  {
    path: "/yichang",
    component: () => import("@/components/wuliu/fenxi/yichang.vue")
  },
  {
    path: "/feiyongleixing",
    component: () => import("@/components/wuliu/fenxi/feiyongleixing.vue")
  },
  {
    path: "/kehudingdan",
    component: () => import("@/components/wuliu/fenxi/kehudingdan.vue")
  },
  {
    path: "/waipai",
    component: () => import("@/components/wuliu/fenxi/waipai.vue")
  },
  {
    path: "/yichangleixing",
    component: () => import("@/components/wuliu/fenxi/yichangleixing.vue")
  }
];
export default data;



// WEBPACK FOOTER //
// ./src/router/wuliu.js